import { render, staticRenderFns } from "./apartment-faq.vue?vue&type=template&id=8ce6ed58&scoped=true&"
import script from "./apartment-faq.ts?vue&type=script&lang=ts&"
export * from "./apartment-faq.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-faq.scss?vue&type=style&index=0&id=8ce6ed58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce6ed58",
  null
  
)

export default component.exports